// extracted by mini-css-extract-plugin
export var dataCell = "_lr-2";
export var dataRow = "_lr-0";
export var headerRow = "_lr-1";